import { useCallback } from "react"

import { Button, Icon } from "semantic-ui-react"
import type { OpenAPI } from "simplydo/interfaces"
import { LabelChooser } from "simplydo/react/components/Choosers/LabelChooser/LabelChooser"

import api from "api"
import { useAppSelector } from "store"
import util from "utils/utils"

type LabelActionProps = {
  idea: OpenAPI.GET<"/ideas/{id}">["response"]
  onUpdateIdea: (idea: Partial<OpenAPI.Schemas["Idea"]>) => void
}

const LabelAction = ({ idea, onUpdateIdea }: LabelActionProps) => {
  const user = useAppSelector((state) => state.user)

  const labelIdea = useCallback(
    (label, isApplied) => {
      let labels = idea.labels || []
      if (labels.includes(label)) {
        if (!isApplied) {
          labels = labels.filter((l) => l !== label)
        }
      } else {
        if (isApplied) {
          labels = [...labels, label]
        }
      }

      api.ideas.updateStatus(
        idea._id,
        { labels },
        () => {
          onUpdateIdea({ labels })
        },
        () => {},
      )
    },
    [idea, onUpdateIdea],
  )

  if (
    !util.canManageChallenge(user, idea.ownerChallenge) &&
    !util.hasPermission(user, "challenge.editIdeaLabels", idea.challenge)
  ) {
    return null
  }

  return (
    <LabelChooser
      challengeId={idea.challenge}
      onComplete={(em) => labelIdea(em, true)}
      existing={idea?.labels}
      onRemoveExisting={(em) => labelIdea(em, false)}
      trigger={
        <Button icon>
          <Icon name="bookmark" />
        </Button>
      }
      tooltip="Label idea"
    />
  )
}

export default LabelAction
